import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';

interface EnabledToggleFieldProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
}

export const EnabledToggleField: React.FC<EnabledToggleFieldProps> = ({
  value,
  onChange,
  disabled = false,
  label = 'Enabled',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={value}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
};
